import React, { useEffect, useMemo, useRef, useState } from 'react';
import floorPlans from '@/components/Plans/floorPlans';
import { useTranslation } from 'react-i18next';

import {
  Button,
  ButtonGroup,
  ButtonToolbar,
  IconButton,
  Input,
  InputNumber,
  Loader,
  Message,
  Panel,
  RadioTile,
  RadioTileGroup,
  Stack,
  Tooltip,
  useToaster,
  Whisper
} from 'rsuite';
import { useAppDispatch, useAppSelector } from '@/config/hooks';
import { getDesksByFloor } from '@/services/desk.service';
import { AiOutlineEdit, AiOutlineSave } from 'react-icons/ai';
import { MdBlock, MdOutlineDeleteOutline } from 'react-icons/md';
import UpdateDrawer from './UpdateDrawer';
import { addZone, getZonesByFloor, removeZone, updateZone } from '@/services/zone.service';
import { AppSelect, Edit, Icon, Minus, Plus, Qrcode } from '@rsuite/icons';
import ConfirmModal from '@/components/ConfirmModal';
import { FaVectorSquare } from 'react-icons/fa6';
import { FaRegCheckSquare } from 'react-icons/fa';
import { IoSquareOutline } from 'react-icons/io5';
import { IoIosClose } from 'react-icons/io';
// import ZonesDrawer from './ZonesDrawer';
import QRCode from 'qrcode';
import { jsPDF } from 'jspdf';
import BlockDrawer from './BlockDrawer';
import { format } from 'date-fns';
import { LuKeyRound } from 'react-icons/lu';
import AccessDrawer from './AccessDrawer';
import parse from 'html-react-parser';

const Floor = ({ floor }) => {
  const dispatch = useAppDispatch();

  const toaster = useToaster();
  const desks = useAppSelector((state: any) => state.desk.data);

  const zones = useAppSelector((state: any) => state.zone.data);
  const loadingZones = useAppSelector((state: any) => state.zone.loading);

  const loadingDesks = useAppSelector((state: any) => state.desk.loading);

  const [FloorPlanComponent, setFloorPlanComponent] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [selectedDesks, setSelectedDesks] = useState<any>([]);
  const [updateDrawer, setUpdateDrawer] = useState<any>({ open: false });
  const [view, setView] = useState('');
  const [svgContent, setSvgContent] = useState(null);
  const svgWrapperRef = useRef(null);
  const [viewBox, setViewBox] = useState('0 0 1200 900');
  const [width, setWidth] = useState(1130);
  const [height, setHeight] = useState(900);

  const [dragging, setDragging] = useState(false);
  const [start, setStart] = useState({ x: 0, y: 0 });

  const [confirmModal, setConfirmModal] = useState<any>({
    open: false,
    title: '',
    subtitle: ''
  });

  const [accessDrawer, setAccessDrawer] = useState<any>({
    open: false,
    id: null
  });

  const [statusDrawer, setStatusDrawer] = useState<any>({ open: false });

  const [editZone, setEditZone] = useState<any>(null);
  const [createZone, setCreateZone] = useState<any>(null);

  const [selectedZones, setSelectedZones] = useState<any>([]);
  const refAm = useRef(null);
  const refPm = useRef(null);

  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (!floor) {
      console.error('Floor data is missing.');
      return;
    }

    dispatch(getZonesByFloor(floor._id));

    dispatch(getDesksByFloor(floor._id));

    // const floorKey = `${floor?.building?.address}.${floor?.floor_num}`;

    // const loadFloorPlan = floorPlans[floorKey];
    // if (!loadFloorPlan) {
    //   console.error(`No floor plan found for key: ${floorKey}`);

    //   setLoading(false);
    //   return;
    // }

    // // setFloorPlanComponent(loadFloorPlan);

    // setLoading(true);

    // console.log('loadFloorPlan', loadFloorPlan);

    // loadFloorPlan()
    //   .then(FloorPlan => {
    //     console.log('FloorPlan', FloorPlan);
    //     setFloorPlanComponent(() => FloorPlan);
    //     setLoading(false);
    //   })
    //   .catch(err => {
    //     console.error(`Error loading floor plan for key: ${floorKey}`, err);
    //     setLoading(false);
    //   });

    if (!floor || !floor.floor_svg) {
      console.error('Floor or svg_plan is missing.');
      return;
    }

    const decodedSvg = floor.floor_svg;
    // if (decodedSvg) {
    //   setSvgContent(parse(decodedSvg));
    //   setLoading(false);
    // }

    if (decodedSvg) {
      let svgWidth = null;
      let svgHeight = null;
      let svgViewBox = null;
      const options = {
        replace: domNode => {
          if (domNode.type === 'tag' && domNode.name === 'svg' && !domNode.attribs?.id) {
            svgWidth = domNode.attribs?.width || null;
            svgHeight = domNode.attribs?.height || null;
            svgViewBox = domNode.attribs?.viewBox || null;
            domNode.attribs.id = 'floor-plan';
          }
          // if (domNode.type === 'tag' && domNode.name === 'svg') {
          //   domNode.attribs.id = 'floor-plan';
          //   delete domNode.attribs.width;
          //   delete domNode.attribs.height;
          //   domNode.attribs.style = 'width: 100%; height: 100%';
          // }
        }
      };

      console.log('decodedSvg', decodedSvg);

      const parsed = parse(decodedSvg, options);
      console.log('svgWidth', svgWidth, svgHeight);
      console.log('svgViewBox', svgViewBox);
      if (svgViewBox) setViewBox(svgViewBox);
      if (svgWidth) setWidth(svgWidth);
      if (svgHeight) setHeight(svgHeight);
      setSvgContent(parsed);

      setLoading(false);
    }
  }, [floor]);

  useEffect(() => {
    setSelectedZones(Array.from(zones, ({ _id }) => _id));
  }, [zones]);

  const handlePathClick = deskId => {
    setSelectedDesks(prevSelected =>
      prevSelected.includes(deskId)
        ? prevSelected.filter(id => id !== deskId)
        : [...prevSelected, deskId]
    );
  };

  const memoizedDesks = useMemo(() => {
    return desks.filter(desk => selectedZones.includes(desk.zone._id));
  }, [selectedZones, desks]);

  const handleDelete = async id => {
    try {
      if (desks.find(desk => desk.zone._id == id)) {
        toaster.push(
          <Message type="error" duration={9000} showIcon>
            You cannot delete a zone that has attached resources !
          </Message>,
          { placement: 'topCenter' }
        );
        setConfirmModal({ open: false });
        return;
      }
      dispatch(await removeZone(floor._id, id))
        .then(() => {
          toaster.push(
            <Message type="success" duration={5000} showIcon>
              {t('Deleted successfully')}
            </Message>,
            { placement: 'topCenter' }
          );
        })
        .catch(e => {
          toaster.push(
            <Message type="error" duration={5000} showIcon>
              {t(e.message)}
            </Message>,
            { placement: 'topCenter' }
          );
        });
    } catch (error) {
      toaster.push(
        <Message type="error" duration={5000} showIcon>
          {t(error.message)}
        </Message>,
        { placement: 'topCenter' }
      );
    }
    setConfirmModal({ open: false });
  };

  const handleUpdateZone = async () => {
    try {
      if (!editZone || !editZone?.name || editZone?.name?.length == 0) {
        toaster.push(
          <Message type="error" duration={5000} showIcon>
            Fill the name please
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      dispatch(await updateZone(floor._id, editZone))
        .then(() => {
          toaster.push(
            <Message type="success" duration={5000} showIcon>
              {t('Updated successfully')}
            </Message>,
            { placement: 'topCenter' }
          );
          setEditZone(null);
        })
        .catch(e => {
          toaster.push(
            <Message type="error" duration={5000} showIcon>
              {t(e.message)}
            </Message>,
            { placement: 'topCenter' }
          );
        });
    } catch (error) {
      toaster.push(
        <Message type="error" duration={5000} showIcon>
          {t(error.message)}
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };

  const handleAddZone = async () => {
    try {
      if (!createZone || !createZone?.name || createZone?.name?.length == 0) {
        toaster.push(
          <Message type="error" duration={5000} showIcon>
            Fill the name please
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      if (zones.find(item => item.name == createZone.name)) {
        toaster.push(
          <Message type="error" duration={5000} showIcon>
            The zone with this name already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      dispatch(await addZone({ floor: { _id: floor._id, name: floor.name }, ...createZone }))
        .then(() => {
          toaster.push(
            <Message type="success" duration={5000} showIcon>
              Created successfully
            </Message>,
            { placement: 'topCenter' }
          );
          setCreateZone(null);
        })
        .catch(e => {
          toaster.push(
            <Message type="error" duration={5000} showIcon>
              {t(e.message)}
            </Message>,
            { placement: 'topCenter' }
          );
        });
    } catch (error) {
      toaster.push(
        <Message type="error" duration={5000} showIcon>
          {t(error.message)}
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };

  const maxScale = 3;
  const minScale = 0.5;

  // const generatePDF = async () => {
  //   const pdf = new jsPDF();
  //   const qrCodeSize = 50; // Taille du QR code en mm
  //   const margin = 10; // Marge en mm
  //   let x = margin,
  //     y = margin;

  //   const selectedDeskList = desks.filter(desk => selectedDesks.includes(desk._id));

  //   for (const desk of selectedDeskList) {
  //     const qrCodeDataUrl = await QRCode.toDataURL(desk.QRCode);

  //     pdf.addImage(qrCodeDataUrl, 'PNG', x, y, qrCodeSize, qrCodeSize);

  //     const textWidth = pdf.getTextWidth(desk.name);
  //     const centeredX = x + (qrCodeSize - textWidth) / 2;

  //     // pdf.text(desk.name, x, y + qrCodeSize + 5);
  //     pdf.text(desk.name, centeredX, y + qrCodeSize + 5);

  //     x += qrCodeSize + margin;
  //     if (x + qrCodeSize > pdf.internal.pageSize.getWidth() - margin) {
  //       x = margin;
  //       y += qrCodeSize + 20;
  //       if (y + qrCodeSize > pdf.internal.pageSize.getHeight() - margin) {
  //         pdf.addPage();
  //         x = margin;
  //         y = margin;
  //       }
  //     }
  //   }

  //   pdf.save('qrcodes.pdf');
  // };

  const createStyledQRCode = async (data: string, label: string): Promise<string> => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;

    // Dimensions du canvas (en pixels, haute résolution pour qualité PDF)
    const canvasWidth = 400;
    const canvasHeight = 550;
    const qrSize = 340;
    const qrMargin = 30;
    const labelHeight = 130;
    const borderWidth = 8;

    canvas.width = canvasWidth;
    canvas.height = canvasHeight;

    // Fond blanc
    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(0, 0, canvasWidth, canvasHeight);

    // Bordure bleue externe
    ctx.strokeStyle = '#ffffffff';
    ctx.lineWidth = borderWidth;
    ctx.strokeRect(
      borderWidth / 2,
      borderWidth / 2,
      canvasWidth - borderWidth,
      canvasHeight - borderWidth
    );

    // Générer le QR code
    const qrCanvas = document.createElement('canvas');
    await QRCode.toCanvas(qrCanvas, data, {
      width: qrSize,
      margin: 0,
      color: {
        dark: '#000080', // Bleu foncé pour le QR code
        light: '#FFFFFF'
      },
      errorCorrectionLevel: 'H'
    });

    // Dessiner le QR code sur le canvas principal
    ctx.drawImage(qrCanvas, qrMargin, qrMargin, qrSize, qrSize);

    // Zone bleue pour le label
    const labelY = qrMargin + qrSize + 50;
    ctx.fillStyle = '#000080';
    ctx.fillRect(borderWidth, labelY, canvasWidth - borderWidth * 2, labelHeight);

    // Texte du label (numéro/nom)
    ctx.fillStyle = '#FFFFFF';
    ctx.font = 'bold 80px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(label, canvasWidth / 2, labelY + labelHeight / 2);

    return canvas.toDataURL('image/png');
  };

  const generatePDF = async () => {
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4'
    });

    const qrCodeSize = 60; // Taille finale en mm dans le PDF
    const margin = 15;
    const spacing = 10;
    let x = margin;
    let y = margin;

    const selectedDeskList = desks.filter(desk => selectedDesks.includes(desk._id));

    for (let i = 0; i < selectedDeskList.length; i++) {
      const desk = selectedDeskList[i];

      // Créer le QR code stylisé
      const styledQRDataUrl = await createStyledQRCode(desk.QRCode, desk.name);

      // Ajouter au PDF
      pdf.addImage(styledQRDataUrl, 'PNG', x, y, qrCodeSize, qrCodeSize * 1.25);

      // Calculer la position pour le prochain QR code
      x += qrCodeSize + spacing;

      // Si on dépasse la largeur de la page, passer à la ligne suivante
      if (x + qrCodeSize > pdf.internal.pageSize.getWidth() - margin) {
        x = margin;
        y += qrCodeSize * 1.25 + spacing;

        // Si on dépasse la hauteur de la page, créer une nouvelle page
        if (y + qrCodeSize * 1.25 > pdf.internal.pageSize.getHeight() - margin) {
          pdf.addPage();
          x = margin;
          y = margin;
        }
      }
    }

    pdf.save(`qrcodes-${floor.name}.pdf`);
  };

  const handleZoomIn = () => {
    setScale(prev => Math.min(prev + 0.2, maxScale));
  };

  const handleZoomOut = () => {
    setScale(prev => Math.max(prev - 0.2, minScale));
  };
  const { t } = useTranslation();

  return (
    <div>
      {loading && <Loader />}
      {/* {!FloorPlanComponent ? ( */}
      {!svgContent ? (
        <div>{t('Unable to load floor plan')}</div>
      ) : loadingDesks ? (
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          style={{ marginTop: 50 }}
        >
          {' '}
          <Loader size="md" />
        </Stack>
      ) : (
        <div className="relative h-full w-full">
          <Stack
            direction="column"
            spacing={10}
            justifyContent="center"
            alignItems="center"
            style={{ marginTop: 20 }}
          >
            {loadingZones ? (
              <Loader />
            ) : (
              <Stack spacing={20} justifyContent="center" alignItems="center" wrap>
                {zones?.map(zone => (
                  <>
                    {editZone?.id === zone._id ? (
                      <Panel
                        key={zone._id}
                        bordered
                        bodyFill
                        style={{
                          minWidth: '200px',
                          minHeight: '90px',
                          cursor: 'pointer',
                          border: '2px solid #e5e5ea',
                          gap: '6px',
                          alignItems: 'center',
                          padding: '5px'
                        }}
                      >
                        <Stack
                          spacing={10}
                          justifyContent="center"
                          alignItems="center"
                          // style={{ marginTop: 10 }}
                        >
                          <Icon as={FaVectorSquare} style={{ color: 'var(--rs-text-primary)' }} />{' '}
                          <label
                            className="rs-radio-tile-label"
                            style={{ color: 'var(--rs-text-primary)' }}
                          >
                            {t('Edit zone')}
                          </label>
                        </Stack>
                        <Stack
                          spacing={10}
                          wrap
                          style={{ marginTop: 12 }}
                          justifyContent="center"
                          alignItems="center"
                          direction="column"
                        >
                          <Input
                            value={editZone?.name}
                            onChange={val => {
                              setEditZone(prevData => ({ ...prevData, name: val }));
                            }}
                            placeholder={t('Name')}
                            style={{ borderLeft: 0, borderRight: 0, borderTop: 0, borderRadius: 0 }}
                          />
                          <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                            <InputNumber
                              value={editZone?.maxOccupation}
                              onChange={val => {
                                setEditZone(prevData => ({ ...prevData, maxOccupation: val }));
                              }}
                              placeholder="Occupancy threshold"
                              type="number"
                              postfix="%"
                              min={0}
                              max={100}
                              style={{
                                borderLeft: 0,
                                borderRight: 0,
                                borderTop: 0,
                                borderRadius: 0,
                                width: '80%'
                              }}
                            />
                          </div>
                        </Stack>
                        <Stack justifyContent="center" alignItems="center" style={{ marginTop: 9 }}>
                          <IconButton
                            appearance="subtle"
                            size="md"
                            icon={<AiOutlineSave color="blue" />}
                            id={`save-${zone.name}`}
                            onClick={e => {
                              e.stopPropagation();
                              handleUpdateZone();
                            }}
                          />
                          <IconButton
                            size="md"
                            appearance="subtle"
                            icon={<IoIosClose color="red" size={20} />}
                            onClick={e => {
                              e.stopPropagation();
                              setEditZone({});
                            }}
                            id={`cancel-${zone.name}`}
                          />
                        </Stack>
                      </Panel>
                    ) : (
                      <RadioTile
                        key={zone._id}
                        // icon={<Icon as={FaVectorSquare} style={{ position: 'a', top: 2 }} />}
                        // label={zone.name}
                        value={zone._id}
                        style={{ minWidth: 200 }}
                        checked={selectedZones.includes(zone._id) ? true : false}
                        className={`${selectedZones.includes(zone._id) ? 'checked' : ''}`}
                        onClick={e => {
                          e.stopPropagation();
                          setSelectedZones(prevSelectedZones =>
                            prevSelectedZones.includes(zone._id)
                              ? prevSelectedZones.filter(id => id !== zone._id)
                              : [...prevSelectedZones, zone._id]
                          );
                        }}
                      >
                        <Stack spacing={10} justifyContent="center" alignItems="center">
                          {/* <Icon as={FaVectorSquare} style={{ color: 'var(--rs-text-primary)' }} />{' '} */}
                          <AppSelect style={{ color: 'var(--rs-text-primary)' }} />
                          <label
                            className="rs-radio-tile-label"
                            style={{ color: 'var(--rs-text-primary)' }}
                          >
                            {zone.name}
                          </label>
                        </Stack>
                        <div style={{ textAlign: 'center', width: '100%', marginTop: 10 }}>
                          Occupancy threshold: {zone.maxOccupation ?? ''}
                        </div>
                        <Stack
                          spacing={10}
                          wrap
                          style={{ marginTop: 10 }}
                          justifyContent="center"
                          alignItems="center"
                        >
                          <div>
                            {t('Available:')}{' '}
                            {
                              desks?.filter(item => item.zone._id == zone._id && !item.isBlocked)
                                ?.length
                            }
                          </div>
                          <div>
                            {t('Blocked:')}{' '}
                            {
                              desks?.filter(
                                item => item.zone._id == zone._id && item.isBlocked == true
                              )?.length
                            }
                          </div>
                        </Stack>
                        <Stack
                          justifyContent="center"
                          alignItems="center"
                          style={{ marginTop: 10 }}
                        >
                          <IconButton
                            appearance="subtle"
                            size="sm"
                            icon={<Edit color="blue" />}
                            id={`edit-${zone.name}`}
                            onClick={e => {
                              e.stopPropagation();
                              setEditZone({
                                id: zone._id,
                                name: zone.name,
                                maxOccupation: zone.maxOccupation
                              });
                            }}
                          />
                          <IconButton
                            size="sm"
                            appearance="subtle"
                            icon={<MdOutlineDeleteOutline color="red" />}
                            onClick={() => {
                              setConfirmModal({
                                open: true,
                                title: 'Are you sure to remove this zone ?',
                                subtitle: 'You cannot undo this operation',
                                onConfirm: () => {
                                  handleDelete(zone._id);
                                }
                              });
                            }}
                            id={`delete-${zone.name}`}
                          />

                          <IconButton
                            size="sm"
                            appearance="subtle"
                            icon={<LuKeyRound />}
                            onClick={() => {
                              setAccessDrawer({
                                open: true,
                                id: zone._id
                              });
                            }}
                            id={`access-${zone.name}`}
                          />
                        </Stack>
                      </RadioTile>
                    )}
                  </>
                ))}

                {createZone?.open ? (
                  <Panel
                    bordered
                    bodyFill
                    style={{
                      minWidth: '200px',
                      minHeight: '90px',
                      cursor: 'pointer',
                      border: '2px solid #e5e5ea',
                      gap: '6px',
                      alignItems: 'center',
                      padding: '5px'
                    }}
                  >
                    <Stack
                      spacing={10}
                      justifyContent="center"
                      alignItems="center"
                      // style={{ marginTop: 10 }}
                    >
                      <Icon as={FaVectorSquare} style={{ color: 'var(--rs-text-primary)' }} />{' '}
                      <label
                        className="rs-radio-tile-label"
                        style={{ color: 'var(--rs-text-primary)' }}
                      >
                        {t('Create zone')}
                      </label>
                    </Stack>
                    <Stack
                      spacing={10}
                      wrap
                      style={{ marginTop: 12 }}
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Input
                        value={createZone?.name}
                        onChange={val => {
                          setCreateZone(prevData => ({ ...prevData, name: val }));
                        }}
                        placeholder={t('Name')}
                        style={{ borderLeft: 0, borderRight: 0, borderTop: 0, borderRadius: 0 }}
                      />
                    </Stack>
                    <Stack justifyContent="center" alignItems="center" style={{ marginTop: 9 }}>
                      <IconButton
                        appearance="subtle"
                        size="md"
                        icon={<AiOutlineSave color="blue" />}
                        id={`create-zone`}
                        onClick={e => {
                          e.stopPropagation();
                          handleAddZone();
                        }}
                      />
                      <IconButton
                        size="md"
                        appearance="subtle"
                        icon={<IoIosClose color="red" size={20} />}
                        onClick={e => {
                          e.stopPropagation();
                          setCreateZone({});
                        }}
                        id={`cancel-add-zone`}
                      />
                    </Stack>
                  </Panel>
                ) : (
                  <Stack className="mb-20">
                    <Panel
                      className="board-box board-new"
                      onClick={() => setCreateZone({ open: true, name: '' })}
                    >
                      <Stack spacing={10} justifyContent="center" alignItems="center">
                        <div className="title">{t('Create new zone')}</div>
                      </Stack>
                    </Panel>
                  </Stack>
                )}
              </Stack>
            )}

            <ButtonToolbar style={{ marginTop: 20, marginBottom: 20 }}>
              <ButtonGroup>
                <Button onClick={handleZoomIn}>
                  <Stack spacing={5}>
                    <Plus /> <p>{t('Zoom in')}</p>
                  </Stack>
                </Button>
                <Button onClick={handleZoomOut}>
                  <Stack spacing={5}>
                    <Minus /> <p>{t('Zoom out')}</p>
                  </Stack>
                </Button>
                {selectedDesks.length == 0 ? (
                  <Stack spacing={10}>
                    <Button onClick={() => setSelectedDesks(desks.map(item => item._id))}>
                      <Stack spacing={5}>
                        <FaRegCheckSquare /> <p>{t('Select all resources')}</p>
                      </Stack>
                    </Button>

                    <p>{t('Or click on the resources')}</p>
                  </Stack>
                ) : (
                  <Button onClick={() => setSelectedDesks(desks.map(item => item._id))}>
                    <Stack spacing={5}>
                      <FaRegCheckSquare /> <p>{t('Select all resources')}</p>
                    </Stack>
                  </Button>
                )}

                {selectedDesks?.length > 0 && (
                  <Button onClick={() => setSelectedDesks([])}>
                    <Stack spacing={5}>
                      <IoSquareOutline /> <p>{t('Unselect all resources')}</p>
                    </Stack>
                  </Button>
                )}
                {selectedDesks?.length > 0 && (
                  <Button
                    onClick={() => {
                      setUpdateDrawer({
                        open: true
                      });
                    }}
                  >
                    <Stack spacing={5}>
                      <AiOutlineEdit /> <p>{t('Edit resources')}</p>
                    </Stack>
                  </Button>
                )}
                {/* {selectedDesks?.length > 0 && (
                  <Button
                    onClick={() => {
                      setStatusDrawer({
                        open: true
                      });
                    }}
                  >
                    <Stack spacing={5}>
                      <MdBlock /> <p>Block/Unblock resources</p>
                    </Stack>
                  </Button>
                )} */}
                {selectedDesks?.length > 0 && (
                  <Button onClick={generatePDF}>
                    <Stack spacing={5}>
                      <Qrcode /> <p>{t('Download QR codes')}</p>
                    </Stack>
                  </Button>
                )}
              </ButtonGroup>
            </ButtonToolbar>
          </Stack>

          <Stack direction="row" spacing={20} justifyContent="center" alignItems="center">
            <svg
              // className="plan"
              //   viewBox="0 0 900 1200"
              // width={1135}
              // height={907}
              // fill="none"
              // //   xmlns="http://www.w3.org/2000/svg"
              // stroke="transparent"
              // strokeWidth={0}
              // style={{ outline: 'none', padding: '50px' }}
              id="floorPlanSVG"
              ref={svgWrapperRef}
              viewBox={viewBox}
              width={width}
              height={height}
              fill="none"
              //   xmlns="http://www.w3.org/2000/svg"
              stroke="transparent"
              strokeWidth={0}
              style={{
                // transform: `scale(${scale})`,
                // transformOrigin: 'top left',
                // transition: 'transform 0.3s ease-in-out',
                maxWidth: '100%',
                maxHeight: '100%',
                width: '100%',
                height: '100%',
                transform: `translate(${position?.x}px, ${position?.y}px) scale(${scale})`,
                // transformOrigin: 'center',
                transformOrigin: 'top left'
                // transition: dragging ? 'none' : 'transform 0.3s ease-in-out',
                // cursor: dragging ? 'grabbing' : 'grab'
              }}
              onMouseDown={e => {
                setDragging(true);
                setStart({ x: e.clientX - position.x, y: e.clientY - position.y });
              }}
              onMouseMove={e => {
                if (!dragging) return;
                setPosition({ x: e.clientX - start.x, y: e.clientY - start.y });
              }}
              onMouseUp={() => setDragging(false)}
              onMouseLeave={() => setDragging(false)}
              onTouchStart={e => {
                if (e.touches.length === 1) {
                  setDragging(true);
                  setStart({
                    x: e.touches[0].clientX - position.x,
                    y: e.touches[0].clientY - position.y
                  });
                }
              }}
              onTouchMove={e => {
                if (!dragging || e.touches.length !== 1) return;
                setPosition({
                  x: e.touches[0].clientX - start.x,
                  y: e.touches[0].clientY - start.y
                });
              }}
              onTouchEnd={() => setDragging(false)}
            >
              {/* <FloorPlanComponent /> */}
              {svgContent}

              {loadingDesks ? (
                <Loader />
              ) : (
                memoizedDesks.map((desk, index) => {
                  return (
                    <>
                      <Whisper
                        key={index}
                        followCursor
                        speaker={
                          <Tooltip>
                            <p>{desk.name + ' / ' + desk.zone.name}</p>
                            <p>
                              {desk.isBlocked == false &&
                              desk.startDate != null &&
                              desk.endDate != null
                                ? `Available only from ${format(
                                    new Date(desk.startDate),
                                    'dd-MM-yyyy'
                                  )} to ${format(new Date(desk.endDate), 'dd-MM-yyyy')} `
                                : desk.isBlocked == true &&
                                  desk.startDate != null &&
                                  desk.endDate != null
                                ? `Blocked only from ${format(
                                    new Date(desk.startDate),
                                    'dd-MM-yyyy'
                                  )} to ${format(new Date(desk.endDate), 'dd-MM-yyyy')} `
                                : ''}
                            </p>
                          </Tooltip>
                        }
                      >
                        <path
                          className="path"
                          id={desk.name}
                          // fill={`${desk.isBlocked == true ? '#bac8d6' : '#14e39a'}`}
                          ref={refAm}
                          d={desk.coordinations_web_am}
                          onClick={() => handlePathClick(desk._id)}
                          style={{
                            cursor: 'pointer',
                            fill: selectedDesks.includes(desk._id)
                              ? '#4096ec'
                              : desk.isBlocked == true && desk.startDate != null
                              ? '#f2b73f'
                              : desk.isBlocked == true
                              ? '#d5131e'
                              : desk.isBlocked == false && desk.startDate != null
                              ? '#a7f21b'
                              : '#14e39a',
                            strokeWidth: selectedDesks.includes(desk._id) ? 2 : 0
                          }}
                        ></path>
                      </Whisper>

                      <Whisper
                        followCursor
                        speaker={
                          <Tooltip>
                            {' '}
                            <p>{desk.name + ' / ' + desk.zone.name}</p>
                            <p>
                              {desk.isBlocked == false &&
                              desk.startDate != null &&
                              desk.endDate != null
                                ? `Available only from ${format(
                                    new Date(desk.startDate),
                                    'dd-MM-yyyy'
                                  )} to ${format(new Date(desk.endDate), 'dd-MM-yyyy')} `
                                : desk.isBlocked == true &&
                                  desk.startDate != null &&
                                  desk.endDate != null
                                ? `Blocked only from ${format(
                                    new Date(desk.startDate),
                                    'dd-MM-yyyy'
                                  )} to ${format(new Date(desk.endDate), 'dd-MM-yyyy')} `
                                : ''}
                            </p>
                          </Tooltip>
                        }
                      >
                        <path
                          className="path"
                          id={desk.name}
                          ref={refPm}
                          // fill={`${desk.isBlocked ? '#bac8d6' : '#14e39a'}`}
                          d={desk.coordinations_web_pm}
                          onClick={() => handlePathClick(desk._id)}
                          style={{
                            cursor: 'pointer',
                            // stroke: selectedDesks.includes(desk.Desk._id)
                            //   ? '#4096ec'
                            //   : 'transparent',
                            fill: selectedDesks.includes(desk._id)
                              ? '#4096ec'
                              : desk.isBlocked == true && desk.startDate != null
                              ? '#f2b73f'
                              : desk.isBlocked == true
                              ? '#d5131e'
                              : desk.isBlocked == false && desk.startDate != null
                              ? '#a7f21b'
                              : '#14e39a',
                            strokeWidth: selectedDesks.includes(desk._id) ? 2 : 0
                          }}
                        ></path>
                      </Whisper>
                    </>
                  );
                })
              )}
            </svg>
          </Stack>

          <Stack direction="row" spacing={20} justifyContent="center" alignItems="center">
            <Stack direction="row" spacing={4} alignItems="center">
              <svg height="15" width="15">
                <circle cx="7.5" cy="7.5" r="5" fill="#14e39a" />
              </svg>
              <span style={{ color: '#32325d', fontSize: '15px' }}>{t('Available')}</span>
            </Stack>

            <Stack direction="row" spacing={4} alignItems="center">
              <svg height="15" width="15">
                <circle cx="7.5" cy="7.5" r="5" fill="#a7f21b" fillOpacity="1" />
              </svg>
              <span style={{ color: '#32325d', fontSize: '15px' }}>
                {t('Available for a period')}
              </span>
            </Stack>

            <Stack direction="row" spacing={4} alignItems="center">
              <svg height="15" width="15">
                <circle cx="7.5" cy="7.5" r="5" fill="#d5131e" fillOpacity="1" />
              </svg>
              <span style={{ color: '#32325d', fontSize: '15px' }}>{t('Blocked')}</span>
            </Stack>
            <Stack direction="row" spacing={4} alignItems="center">
              <svg height="15" width="15">
                <circle cx="7.5" cy="7.5" r="5" fill="#f2b73f" fillOpacity="1" />
              </svg>
              <span style={{ color: '#32325d', fontSize: '15px' }}>
                {t('Blocked for a period')}
              </span>
            </Stack>
          </Stack>
        </div>
      )}

      {updateDrawer.open && (
        <UpdateDrawer
          open={updateDrawer.open}
          onClose={() => setUpdateDrawer({ open: false })}
          selectedDesks={selectedDesks}
          setSelectedDesks={setSelectedDesks}
          floor={floor}
        />
      )}

      {statusDrawer.open && (
        <BlockDrawer
          open={statusDrawer.open}
          onClose={() => setStatusDrawer({ open: false })}
          selectedDesks={selectedDesks}
          setSelectedDesks={setSelectedDesks}
          floor={floor}
        />
      )}

      {confirmModal.open && (
        <ConfirmModal confirmDialog={confirmModal} setConfirmDialog={setConfirmModal} />
      )}

      {accessDrawer.open && (
        <AccessDrawer
          open={accessDrawer.open}
          onClose={() => setAccessDrawer({ open: false, id: null })}
          accessDrawer={accessDrawer}
        />
      )}
    </div>
  );
};

export default Floor;
